// Letris — entry point
import './styles.css';
import { App } from './app.js';

// iOS/iPadOS Safari ignora user-scalable=no para pinch.
// gesturestart/change/end: bloquea pinch-zoom sin afectar a pointer events.
// (NO usar touchend preventDefault: rompe la síntesis de pointerup → tap.)
document.addEventListener('gesturestart',  (e) => e.preventDefault());
document.addEventListener('gesturechange', (e) => e.preventDefault());
document.addEventListener('gestureend',    (e) => e.preventDefault());

App.init();
